import ReactGA from 'react-ga4'
export const DLC = () => {
    return (
        <>
            <div className='py-12 w-full text-center mx-auto'>
                <span className='newicon-mobilenav relative pt-2'>
                    <h1 className='md:hidden text-gradient-title text-xlg font-pop inline-block'>DLC</h1>{' '}
                </span>
            </div>{' '}
            <div className='lg:px-12'>
                {' '}
                <section
                    id='ltdedition'
                    className='max-w-[1000px] md:my-20 md:pb-20 mx-auto section-deco text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5  mt-12'
                >
                    {' '}
                    <div className='flex justify-center mt-20'>
                        <img
                            className=''
                            alt='limited edition'
                            src={`${process.env.PUBLIC_URL}/images/dlc/header-dlc-limited.webp`}
                        />
                    </div>{' '}
                    <div className=' mt-20'>
                        <h1 className='text-lmd text-center mt-4 text-pborange'>Marona & Ash Phantom Isle Outfits</h1>
                        <p className='text-center text-caption'>(Nintendo Switch™, PlayStation®5, and PlayStation®4)</p>
                        <div className='mt-8 flex justify-center max-w-[600px] mx-auto'>
                            <img
                                className=''
                                alt='limited edition'
                                src={`${process.env.PUBLIC_URL}/images/dlc/PhantomBrave_TheLostHero_MaronaAsh_PhantomIsleOutfits.webp`}
                            />
                        </div>{' '}
                        <p className='mt-4 text-center'>Available for free until February 13, 2025 at 6 am PT</p>
                    </div>{' '}
                    <div className=' mt-20'>
                        {' '}
                        <h1 className='text-lmd text-center mt-4 text-pborange'>Exclusive Putty Outfit: Minty</h1>
                        <p className='text-center text-caption'>(Nintendo Switch™)</p>
                        <div className='mt-8 flex justify-center max-w-[600px] mx-auto'>
                            <img
                                className=''
                                alt='limited edition'
                                src={`${process.env.PUBLIC_URL}/images/dlc/PhantomBrave_TheLostHero_ExclusivePuttyOutfit_Minty.webp`}
                            />
                        </div>{' '}
                        <p className='mt-4 text-center'>Available for free until February 13, 2025 at 6 am PT</p>
                    </div>{' '}
                    <p className='text-center mt-20'>
                        Add the free bonus DLC to your account before they are gone forever!
                    </p>
                </section>
                <section
                    id='ltdedition'
                    className='max-w-[1000px] md:my-20 md:pb-20 mx-auto section-deco text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5  mt-12'
                >
                    {' '}
                    <div className='flex justify-center mt-20'>
                        <img
                            className=''
                            alt='limited edition'
                            src={`${process.env.PUBLIC_URL}/images/dlc/header-dlc.webp`}
                        />
                    </div>{' '}
                    <img
                        className='mt-8'
                        alt='limited edition'
                        src={`${process.env.PUBLIC_URL}/images/dlc/dlc-all.webp`}
                    />
                    <p className='mt-8'>
                        Characters from popular Nippon Ichi Software titles will be joining the world of Phantom Brave:
                        The Lost Hero as DLC!
                    </p>
                    <p>
                        Enjoy favorites from the original{' '}
                        <span className='hover:text-pborange cursor-pointer duration-300 underline'>
                            {' '}
                            <a target='_blank' rel='noreferrer' href='https://nisamerica.com/phantombrave-remastered/'>
                                Phantom Brave
                            </a>
                        </span>{' '}
                        to{' '}
                        <span className='hover:text-pborange cursor-pointer duration-300 underline'>
                            <a target='_blank' rel='noreferrer' href='https://nisamerica.com/yomawari/'>
                                Yomawari: Night Alone
                            </a>
                        </span>
                        's <span className='text-pborange'>Kotomo</span> and even{' '}
                        <span className='text-pborange'>Samayoi, the Wanderer</span> from the Japan-exclusive{' '}
                        <span className='hover:text-pborange cursor-pointer duration-300 underline'>
                            <a target='_blank' rel='noreferrer' href='https://nippon1.jp/consumer/barstellaabyss/'>
                                BAR Stella Abyss
                            </a>
                        </span>
                        !
                    </p>
                    <p className='mt-8'>Stay tuned for more details coming soon!</p>
                    <div className='my-20'>
                        <h1 className='text-lmd text-center my-4'>
                            <span className='hover:text-pborange cursor-pointer duration-300 underline'>
                                {' '}
                                <a target='_blank' rel='noreferrer' href='https://nisamerica.com/yomawari/'>
                                    Yomawari: Night Alone's Kotomo
                                </a>
                            </span>
                        </h1>
                        <img
                            className=''
                            alt='limited edition'
                            src={`${process.env.PUBLIC_URL}/images/dlc/dlc-yomawari.webp`}
                        />{' '}
                        <h1 className='text-base text-center my-4'>
                            Bonus Character: <span className='text-pborange'>Kotomo</span>
                        </h1>
                    </div>{' '}
                    <div className='my-20'>
                        <h1 className='text-lmd text-center my-4'>
                            From{' '}
                            <span className='hover:text-pborange cursor-pointer duration-300 underline'>
                                <a target='_blank' rel='noreferrer' href='https://www.nisamerica.com/mad-rat-dead/'>
                                    MAD RAT DEAD
                                </a>
                            </span>
                        </h1>
                        <img
                            className=''
                            alt='limited edition'
                            src={`${process.env.PUBLIC_URL}/images/dlc/dlc-mrd.webp`}
                        />{' '}
                        <h1 className='text-base text-center my-4'>
                            Bonus Character: <span className='text-pborange'>Mad Rat & Heart</span>
                        </h1>
                    </div>{' '}
                    <div className='my-20'>
                        <h1 className='text-lmd text-center my-4'>
                            From{' '}
                            <span className='hover:text-pborange cursor-pointer duration-300 underline'>
                                {' '}
                                <a
                                    target='_blank'
                                    rel='noreferrer'
                                    href='https://nisamerica.com/phantombrave-remastered/'
                                >
                                    Phantom Brave
                                </a>
                            </span>
                        </h1>
                        <div className='pb-8'>
                            <img
                                className=''
                                alt='limited edition'
                                src={`${process.env.PUBLIC_URL}/images/dlc/dlc-castile.webp`}
                            />{' '}
                            <h1 className='text-base text-center my-4'>
                                Bonus Character: <span className='text-pborange'>Castile</span>
                            </h1>
                        </div>{' '}
                        <div className='pb-8'>
                            {' '}
                            <img
                                className=''
                                alt='limited edition'
                                src={`${process.env.PUBLIC_URL}/images/dlc/dlc-walnut.webp`}
                            />{' '}
                            <h1 className='text-base text-center my-4'>
                                Bonus Character: <span className='text-pborange'>Walnut</span>
                            </h1>
                        </div>
                        <div className='pb-8'>
                            {' '}
                            <img
                                className=''
                                alt='limited edition'
                                src={`${process.env.PUBLIC_URL}/images/dlc/dlc-scarlet.webp`}
                            />{' '}
                            <h1 className='text-base text-center my-4'>
                                Bonus Character: <span className='text-pborange'>Scarlet</span>
                            </h1>
                        </div>
                        <div>
                            {' '}
                            <img
                                className=''
                                alt='limited edition'
                                src={`${process.env.PUBLIC_URL}/images/dlc/dlc-sprout.webp`}
                            />{' '}
                            <h1 className='text-base text-center my-4'>
                                Bonus Character: <span className='text-pborange'>Sprout</span>
                            </h1>
                        </div>
                    </div>
                    <div className='my-20'>
                        <h1 className='text-lmd text-center my-4'>
                            From{' '}
                            <span className='hover:text-pborange cursor-pointer duration-300 underline'>
                                <a target='_blank' rel='noreferrer' href='https://nippon1.jp/consumer/barstellaabyss/'>
                                    BAR Stella Abyss
                                </a>
                            </span>
                        </h1>
                        <img
                            className=''
                            alt='limited edition'
                            src={`${process.env.PUBLIC_URL}/images/dlc/dlc-samayoi.webp`}
                        />{' '}
                        <h1 className='text-base text-center my-4'>
                            Bonus Character: <span className='text-pborange'>Samayoi, the Wanderer</span>
                        </h1>
                    </div>
                    <div className='my-20'>
                        <h1 className='text-lmd text-center my-4'>
                            From{' '}
                            <span className='hover:text-pborange cursor-pointer duration-300 underline'>
                                <a
                                    target='_blank'
                                    rel='noreferrer'
                                    href='https://www.nisamerica.com/the-liar-princess/'
                                >
                                    The Liar Princess and the Blind Prince
                                </a>
                            </span>
                        </h1>{' '}
                        <img
                            className=''
                            alt='limited edition'
                            src={`${process.env.PUBLIC_URL}/images/dlc/dlc-liarprincess.webp`}
                        />{' '}
                        <h1 className='text-base text-center my-4'>
                            Bonus Character: <span className='text-pborange'>The Liar Princess</span>
                        </h1>
                    </div>
                </section>
            </div>
        </>
    )
}
